import React from 'react';
import { useChat } from '../context/ChatContext';
import { Check, ShoppingCart } from 'lucide-react';

export function ShoppingListButton() {
  const { shoppingList } = useChat();
  const [open, setOpen] = React.useState(false);

  const total = shoppingList.selected.length;
  const doneCount = shoppingList.selected.reduce((acc, name) => acc + (shoppingList.completed.has(name) ? 1 : 0), 0);

  // Hide shopping list when there is only 1 or 0 items total
  if (!shoppingList.confirmed || total <= 1) return null;

  return (
    <div className="w-full px-8 flex justify-start">
      <div className="flex flex-col border border-primary rounded-lg" style={{
        borderColor: 'var(--primary)'
      }}>
        {open && (
          <div className="w-flex rounded-lg p-[10px]" style={{
            backgroundColor: 'var(--background)'          }}>
            <ul className="space-y-[10px]">
              {shoppingList.selected.map((name) => {
                const isDone = shoppingList.completed.has(name);
                return (
                  <li key={name} className="flex items-center gap-[10px]">
                    <span
                      className="inline-flex items-center justify-center w-[14px] h-[14px] rounded-full border"
                      style={{
                        backgroundColor: isDone ? 'var(--primary)' : 'transparent',
                        borderColor: isDone ? 'var(--primary)' : 'var(--border)',
                        color: isDone ? 'var(--text-primary)' : 'transparent',
                      }}
                      aria-hidden="true"
                    >
                      {isDone && <Check className="w-[14px] h-[14px]" />}
                    </span>
                    <span className="text-[14px]" style={{ 
                      color: 'var(--text-secondary)'
                    }}>
                      {name}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="w-flex inline-flex items-center gap-1.5 px-2.5 py-[5px] text-[12px] font-medium rounded-lg transition-colors hover:opacity-80"
          style={{
            backgroundColor: 'var(--background)',
            color: 'var(--text-secondary)'
          }}
          aria-expanded={open}
          aria-label={`Shopping list ${doneCount}/${total}`}
        >
          <ShoppingCart className="w-[14px] h-[14px]" />
          <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 text-[14px] tabular-nums"
            style={{
              backgroundColor: 'var(--background)',
              color: 'var(--text-secondary)'
            }}
          >
            {doneCount}
          </span>
          <span className="text-[14px]">/</span>
          <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 text-[14px] tabular-nums"
            style={{
              backgroundColor: 'var(--background)',
              color: 'var(--text-secondary)'
            }}
          >
            {total}
          </span>
        </button>
      </div>
    </div>
  );
}


